<template>
  <div class="bg-white shadow overflow-hidden rounded-md">
    <ul role="list" class="divide-y divide-gray-200">
      <template v-for="detention in detentions">
        <detention v-bind:key="detention.id" :detention="detention"/>
      </template>
    </ul>
  </div>
</template>

<script>
import Detention from '@/components/Detention'

export default {
  name: 'detention-list',
  components: { Detention },

  data() {
    return {
      intervalID: undefined,
      detentions: []
    }
  },

  created() {
    this.getDetentions()
    this.intervalID = this.interval()
  },
  beforeDestroy() {
    clearInterval(this.intervalID);
  },
  methods: {
    getDetentions: async function () {
      let devid = this.$store.state.data.devid
      const response = await this.$http.get(`/detentions?devid=${devid}`)
      this.detentions = response.data.detentions
    },
    interval: function(){
      setInterval(function () {
        this.getDetentions()
      }.bind(this), 30000);
    },
  }

}
</script>
